/**
 * 只是input输入框的校验使用此自定义校验，其余的，不需要使用此自定义校验
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export const checkStringNull = (rule, value, callback) => {
  if (value == null || value.trim() == '') {
    console.log('checkStringNull', value);
    return callback(new Error(rule.message));
  } else {
    callback();
  }
};

export const SpecialCharacterCheck = (rule, value, callback) => {
  if (value != null) {
    var reg = /^&*<*>*\$$/;
    if (reg.test(value)) {
      return callback(new Error(rule.message));
    }
  }
  callback();
};
